import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import AddNewUserBtn from '../mui/AddNewUserBtn';
import CusLink from '../../../../components/material-ui/CusLink';
import ChangeStatus from '../../modal/ChangeStatus';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import ChangePas from '../../modal/ChangePas';
import BlockDeposit from '../../modal/BlockDeposit';
import AccessRights from '../../modal/AccessRights';
import PassportDetails from '../../modal/PassportDetails';
import { useEventListener } from 'usehooks-ts';
import { ENUM_USERS_TYPE } from '../../../../enums/enums';
import WriteTgModal from '../../modal/WriteTg';
import ChangeBalance from '../../modal/change_balance/ChangeBalance';
import DeleteAccount from '../../modal/DeleteAccount';
import { useAppSelector } from '../../../../store';

export default function MenuActions({ user = {}, setSelectUserFull, hideAddUser }) {
  const { t } = useTranslation();
  const { isLessTablet } = useBootstrapSize();
  const userId = useAppSelector((state) => state.user.id);

  const [openChangeStatus, setOpenChangeStatus] = useState(false);
  const [openChangePas, setOpenChangePas] = useState(false);
  const [openChangeBalance, setOpenChangeBalance] = useState(false);
  const [openBlockDep, setOpenBlockDep] = useState(false);
  const [openPasDetail, setOpenPasDetail] = useState(false);
  const [openAccessRights, setOpenAccessRights] = useState(false);
  const [openWriteTg, setOpenWriteTg] = useState(false);
  const [openDeleteAcc, setOpenDeleteAcc] = useState(false);

  const isGamer = user.type == ENUM_USERS_TYPE.gamer;

  const actions = [
    { id: 'changeStatus', label: 'Change status', onClick: setOpenChangeStatus },
    { id: 'ChangePas', label: 'Change password', onClick: setOpenChangePas },
    isGamer && { id: 'chBal', label: 'Balance change', onClick: setOpenChangeBalance },
    // { id: 'pasDetails', label: 'Passport details', onClick: setOpenPasDetail },
    isGamer && { id: 'blockingDep', label: 'Anti-fraud for deposits', onClick: setOpenBlockDep },
    user.userId != userId && {
      id: 'accessRights',
      label: 'Access rights',
      onClick: setOpenAccessRights
    },
    { id: 'deleteAcc', label: 'Delete account', onClick: setOpenDeleteAcc }
  ].filter((el) => el);

  if (user?.telegram?.id) {
    actions.push({ id: 'tgChat', label: 'Telegram chat with the player', onClick: setOpenWriteTg });
  }

  useEventListener('openBlockDeposit', () => {
    setOpenBlockDep(true);
  });

  useEventListener('openChangeStatus', () => {
    setOpenChangeStatus(true);
  });

  useEventListener('openWriteTg', () => {
    setOpenWriteTg(true);
  });

  return (
    <>
      <ShowContainer condition={Object.keys(user).length}>
        <Stack gap={1}>
          <Typography fontSize={16} fontWeight={600}>
            {t('Actions')}
          </Typography>
          <Stack gap={0.25}>
            <ShowContainer condition={isLessTablet && !hideAddUser}>
              <AddNewUserBtn />
            </ShowContainer>

            {actions.map((el) => (
              <CusLink linkComponent="button" key={el.id} text={el.label} onClick={el.onClick} />
            ))}
          </Stack>
        </Stack>
      </ShowContainer>

      <ChangeStatus
        open={openChangeStatus}
        setSelectUserFull={setSelectUserFull}
        closeModal={() => setOpenChangeStatus(false)}
        user={user}
      />

      <ChangePas open={openChangePas} closeModal={() => setOpenChangePas(false)} user={user} />

      <ChangeBalance
        open={openChangeBalance}
        closeModal={() => setOpenChangeBalance(false)}
        user={user}
      />

      <PassportDetails
        open={openPasDetail}
        closeModal={() => setOpenPasDetail(false)}
        user={user}
      />

      <BlockDeposit open={openBlockDep} closeModal={() => setOpenBlockDep(false)} user={user} />

      <AccessRights
        open={openAccessRights}
        closeModal={() => setOpenAccessRights(false)}
        user={user}
      />

      <WriteTgModal open={openWriteTg} closeModal={() => setOpenWriteTg(false)} user={user} />

      <DeleteAccount open={openDeleteAcc} closeModal={() => setOpenDeleteAcc(false)} user={user} />
    </>
  );
}
